module.exports = __webpack_public_path__ + "img/standequip.a580e0f3.svg";